module.exports = __webpack_public_path__ + "img/img_userinfo.b3d88a74.png";